<template>
  <transition name="search-popup">
    <div class="search-modal modal-mask">
      <section class="modal-wrapper">
        <h1 class="popup-title" tabindex="1">태그 검색 팝업</h1>
        <SearchTagCatalog
          :isplayymovie="isplayymovie"
          :search-page-type="searchPageType"
        />
      </section>
      <div class="popup-close-box">
        <button type="button" class="popup-close ir" id="search-popup-close" @click="closeSearchPopup()">팝업 닫기</button>
      </div>
    </div>
  </transition>
</template>

<script>
import SearchTagCatalog from '@/components/search/data/SearchTagCatalog'
import { CLOSE_SEARCH_POPUP_EVENT } from '@/common/resources/const'

export default {
  components: {
    SearchTagCatalog // 태그 검색
  },
  props: {
    closeSearchPopup: {
      type: Function
    },
    searchPageType: {
      type: String
    },
    isplayymovie: {
      type: String,
      default: 'y'
    }
  },
  created () {
    this.$events.$on(CLOSE_SEARCH_POPUP_EVENT, () => {
      this.closeSearchPopup()
    })
  },
  beforeDestroy () {
    this.$events.$off(CLOSE_SEARCH_POPUP_EVENT)
  }
}
</script>
<style>
.search-popup-enter-active, .search-popup-leave-active {
  transition: opacity .3s
}
.search-popup-enter, .search-popup-leave-to { /* .fade-leave-active below version 2.1.8 */
  opacity: 0
}
</style>
